import React from "react"
import styledComponent from "styled-components"

const ChevronDiv = styledComponent.div`
    list-style-type: none;
    display: inline-block;
    margin-left: 10px;
    margin-right: 10px;
    height: ${props => props.height || 50}px;
    line-height: ${props => props.height || 50}px;
    padding-left: ${props => (props.height || 50) / 4}px;
    background: ${props => props.background || "grey"};
    text-align: center;
    position: relative;
    cursor: pointer;
    &::before {
        content: "";
        border-left: ${props => (props.number === 0 ? 0 : (props.height || 50) / 2)}px solid transparent;
        border-top: ${props => (props.height || 50) / 2}px solid
            ${props => props.background || "grey"};
        border-bottom: ${props => (props.height || 50) / 2}px solid
            ${props => props.background || "grey"};
        border-right: 0;
        position: absolute;
        left: -${props => (props.height || 50) / 2}px;
    }
    &::after {
        content: "";
        border-left: ${props => (props.height || 50) / 2}px solid
            ${props => props.background || "grey"};
        border-top: ${props => (props.height || 50) / 2}px solid transparent;
        border-bottom: ${props => (props.height || 50) / 2}px solid transparent;
        border-right: 0;
        position: absolute;
        right: -${props => (props.height || 50) / 2}px;
    }
    &:hover {
        background: ${props => props.hover || "lightgrey"};
    }
    &:hover::after {
        border-left: ${props => (props.height || 50) / 2}px solid
            ${props => props.hover || "lightgrey"};
    }
    &:hover::before {
        content: "";
        border-top: ${props => (props.height || 50) / 2}px solid
            ${props => props.hover || "lightgrey"};
        border-bottom: ${props => (props.height || 50) / 2}px solid
            ${props => props.hover || "lightgrey"};
    }
`

function Chevron({ green, ...otherProps }) {
    let greenProps = green ? { background: "rgb(69, 75, 88)", hover: "orange" } : {}
    return <ChevronDiv className="chevron" {...greenProps} {...otherProps} />
}

Chevron.propTypes = {}

export default Chevron



// WEBPACK FOOTER //
// ./src/ui/legacy/Chevron.js